<div class="main">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="header">
        <div class="headerLabel">
          Free Load Dashboard
        </div>
        <div class="refreshIcon" (click)="getOrders()">
          <img src="assets/refresh_new.svg" alt="">
        </div>
      </div>
      <div class="tabs">
        <nav class="nav" id="main-nav">
          <div class="inner">
              <ul>
                  <li [ngClass]="{'active' : tabIndex==0}" (click)='switchTab(0)'><span>Initial Allocation <br> <p style="font-size: 10px; color: #18be8a;margin: 4px 0;">(Suggested by algorithm)</p></span></li>
                  <li [ngClass]="{'active' : tabIndex==1}" (click)='switchTab(1)'><span>Final Allocation</span></li>
              </ul>
              <span class="indicator"></span>
          </div>
      </nav>
      </div>
      <!-- <div class="buttons">
        <div *ngIf="tabIndex == 0" class="downloadButton">
          <img src="assets/download-icon-new.svg" alt="">
        </div>
        <div *ngIf="tabIndex == 0" class="uploadButton" (click)="openLoadBulkUpload();">
          <img src="assets/upload_file.svg" alt="">
          <div class="buttonLabel">
            Load Bulk Upload
          </div>
        </div>
        <div class="newButton" (click)="allocate()">
          <div class="label">
            Allocate
          </div>
        </div>
        
      </div> -->
      <div class="table">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  
          <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <th class="customHeader" mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? toggleAllRows() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                            [aria-label]="checkboxLabel()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)"
                            [aria-label]="checkboxLabel(row)">
              </mat-checkbox>
            </td>
          </ng-container>
  
          <ng-container matColumnDef="Sno">
            <th class="customHeader" mat-header-cell *matHeaderCellDef> S No. </th>
            <td mat-cell *matCellDef="let element"> {{element.sno}} </td>
          </ng-container>
          <ng-container matColumnDef="availableLoad">
            <th class="customHeader" mat-header-cell *matHeaderCellDef> Available Load </th>
            <td mat-cell *matCellDef="let element"> 
                <div *ngFor="let load of element.availableLoad">
                    {{load}}
                </div>    
            </td>
          </ng-container>
          <ng-container matColumnDef="customerDetails">
            <th class="customHeader" mat-header-cell *matHeaderCellDef> Customer Details </th>
            <td mat-cell *matCellDef="let element"> 
                {{element.customerDetails}}  
                <br>
                {{element.state}}
            </td>
          </ng-container>
          <ng-container matColumnDef="material">
            <th class="customHeader" mat-header-cell *matHeaderCellDef> Material </th>
            <td mat-cell *matCellDef="let element"> 
                {{element.material}}  
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="allocationHeader">
              <div style="position: relative;top: 10px;">{{'ORDER_DASHBOARD.action'
                | translate}}</div>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon class="more-icon" [matMenuTriggerFor]="actions"
                (click)="$event.stopPropagation()" style="cursor:pointer">
                more_vert</mat-icon>
              <mat-menu #actions="matMenu">
                

                  <button mat-menu-item                                    
                  (click)="acceptLoad(element)">
                  {{'ORDER_DASHBOARD.accept' | translate}}</button>
                 
                
              </mat-menu>
              <div class="rejected" *ngIf="element.disable_btns">
                <p style="color: #D8511F;">Rejected</p>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
              (click)="selection.toggle(row)">
          </tr>
        </table>
        <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                   showFirstLastButtons
                   aria-label="Select page of periodic elements">
    </mat-paginator> -->
        
      </div>
      <div class="footer">
        <mat-paginator fixed [length]="(dataSource)? totalOrders:0" [showFirstLastButtons]="true" [pageSize]="25"
        style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"
        [pageSizeOptions]="[5, 10, 25, 100]" (page)="pageNavigate($event)"></mat-paginator>
        </div>
    </div>
  </div>
  
  <ng-template #reportDialog>
    <div class="Report_dialog">
      <div class="header">
        <i class="material-icons" (click)="reportDialogRef.close()">clear</i>
      </div>
      <div class="section">
        <div class="filter_container">
          <div class="left_sec">
            <div class="input_select">
              <input type="text" class="inputField" placeholder="Date From" [(ngModel)]="reportFromDate"
                (click)="fromDateInput2.open()" [matDatepicker]="fromDateInput2" />
              <mat-datepicker #fromDateInput2></mat-datepicker>
              <span class="calendaricon">
                <img src="assets/calender-icon.svg" alt="Calender"> </span>
            </div>
          </div>
          <div class="left_sec">
            <div class="input_select">
              <input type="text" class="inputField" placeholder="Date To" [(ngModel)]="reportToDate"
                (click)="toDateInput2.open()" [matDatepicker]="toDateInput2" />
              <mat-datepicker #toDateInput2></mat-datepicker>
              <span class="calendaricon">
                <img src="assets/calender-icon.svg" alt="Calender"> </span>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <div class="clear_btn" (click)="clearReportDialog()">Clear</div>
        <div class="submit_btn" (click)="generateReport()">Download</div>
      </div>
    </div>
  </ng-template>
  <!-- <ng-template #loadBulkUploadDialog>
    <div class="bulkUploadDialog">
      <div class="header">
        Load Bulk Upload
        <!-- <i class="material-icons" (click)="reportDialogRef.close()">clear</i>
      </div>
      <div class="section">
       <div class="clientDetails">
        <div class="label">
          Client
        </div>
        <div class="dropDown">
          <mat-select class="inputSelect" [(ngModel)]="selectedOrganization" style="color: #fff;">
              <mat-option *ngFor="let org of organizationsArray" [value]="org">
                {{org.name}}
              </mat-option>
            </mat-select>
      </div>
       </div>
       <div class="container" appDnd (fileDropped)="onFileDropped($event)">
        <input type="file" #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event.target.files)" />
        <img src="assets/uploadBlue.svg" alt="">
      
        <div class="info">Drag and Drop to upload the files here.</div>
        <div class="newButton" for="fileDropRef" [disabled]="files.length">
          <div class="label">
            Browse and Upload
          </div>
        </div>
        <div class="note">
          Only <span>CSV</span> file format will be accepted.
        </div>
      </div>
      <div class="filesList" *ngIf="files.length">
        <div class="singleFile">
          <div class="left">
            <div class="fileIcon">
              <img src="assets/csv_icon.svg" alt="">
            </div>
            <div class="info">
              <div class="name">
                {{ files[0]?.name }}
              </div>
              <div class="size">
                {{ formatBytes(files[0]?.size) }}
              </div>
              <app-progress [progress]="files[0]?.progress"></app-progress>
            </div>
          </div>
          <div class="delete" (click)="deleteFile(0)">
            <img src="assets/cancel_file_icon.svg" alt="">
          </div>
        </div>
      </div>
       <div *ngIf="!files.length" class="noFilesChoosen">
        No file chosen
       </div>
       <div class="footer">
        <div class="footerPart">
          <div class="leftDetails" (click)="downloadSample();">
            <img src="assets/download_sample_icon.svg" alt="">
            <div class="downloadNote">
              Download Load Sample
            </div>
          </div>
        </div>
        <div class="footerPart">
          <div class="buttons">
            <div class="newButton" (click)="upload();">
              <div class="label">
                Upload
              </div>
            </div>
            <div class="newButton" style="background-color: #fff; border: solid 1px #dfe3eb;" (click)="closeUploadDialog()">
              <div class="label" style="color: #717478; ">
                Cancel
              </div>
            </div>
          </div>
        </div>
       </div>
      </div>
    </div>
  </ng-template> -->
  <ng-template #editCarrierLoad>
  <div class="editCarrierLoad">
    <div class="section">
      <div class="header">
        Edit Carrier Load
      </div>
      <div class="details">
        <div class="detail">
          <div class="label">
            Material & Quantity
          </div>
          <div class="info">
            {{selectedData.materials}} <br> {{selectedData.totalWeight}} MT
          </div>
        </div>
        <div class="detail">
          <div class="label">
            City/State
          </div>
          <div class="info">
            {{selectedData.city}} <br> {{selectedData.state}}
          </div>
        </div>
        <div class="detail">
          <div class="label">
            Customer Details
          </div>
          <div class="info">
            {{selectedData.customer}}
          </div>
        </div>
        <div class="detail">
          <div class="label">
            Reason
          </div>
          <div class="info">
            <textarea name="" id="" cols="30" rows="10" [(ngModel)]="reason"></textarea>
          </div>
        </div>
      </div>
      <div class="tableSection">
        <div class="row" style="border-bottom: solid 1px #F0F3F9;">
          <div class="headLabel" style="color: #42454E;">Carrier Name</div>
          <!-- <div class="headLabel" style="color: #42454E">Load %</div> -->
          <div class="headLabel" style="color: #42454E">Allocated by Formula</div>
          <div class="headLabel" style="color: #42454E">Allocated Manually</div>
        </div>
        <div class="row" *ngFor="let item of selectedData.allocations; let i=index">
          <div class="headLabel">{{item.carrier.parent_name || 'N/A'}}</div>
          <!-- <div class="headLabel">{{item.loadPercentage || 'N/A'}}</div> -->
          <div class="headLabel">{{item.allocated}} MT</div>
          <div class="headLabel"><input type="number" [ngStyle]="{'border':(item.invalid ? 'solid 1px red' : 'solid 1px #71747A') }" [(ngModel)]="item.editAllocated" (keyup)="checkTotal(i)" ></div>
        </div>
      </div>
      <div class="buttons">
        <div class="newButton" (click)="editLoad();">
          <div class="label">
            EDIT
          </div>
        </div>
        <div class="cancelButton" (click)="editDialogRef.close()">
          <div class="label">
            Cancel
          </div>
        </div>
      </div>
    </div>
  </div>
  </ng-template>